// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1cY6v","title":"BackImages_title__2EpGH","images":"BackImages_images__3SzBO"};